module.exports = __webpack_public_path__ + "static/media/icon-arrow-left.bb7d3770.svg";